import { SvgIcon } from "@mui/material";
import React from "react";

const PickingIcon = (props) => {
	return (
		<SvgIcon {...props} viewBox="0 0 512 512">
			<svg fill="rgba(0, 0, 0, 0.54)">
				<path d="M165.5 391h-90V271H0v241h241V271h-75.5z" />
				<path d="M105.5 271h30v90h-30zM436.5 0v120h-90V0H271v241h241V0z" />
				<path d="M376.5 0h30v90h-30zM436.5 391h-90V271H271v241h241V271h-75.5z" />
				<path d="M376.5 271h30v90h-30zM165.5 0h-90v120.5H0L120.5 241 241 120.5h-75.5z" />
			</svg>
		</SvgIcon>
	);
};
export default PickingIcon;
